import React from 'react'
import { createTheme, MantineProvider } from '@mantine/core'
import ArrowIcon from '../svg/arrrow-down'

const mantineTheme = createTheme({
  colorScheme: 'light',
  primaryColor: 'orange',
  fontFamily: 'Roboto',
  scale: 1,
  headings: {
    fontFamily: 'Roboto-Medium',
  },
  colors: {
    orange: [
      '#FFF4E6',
      '#FFE8CC',
      '#FFF4F0',
      '#FFC078',
      '#FFA94D',
      '#FF922B',
      '#FD5C1F',
      '#F76707',
      '#E8590C',
      '#D9480F',
    ],
  },
  breakpoints: {
    xs: '100px',
    sm: '768px',
    md: '64em',
    lg: '1200px',
    xl: '90em',
  },
  components: {
    Select: {
      defaultProps: {
        withCheckIcon: false,
        allowDeselect: false,
        rightSection: <ArrowIcon />,
      },
      styles: {
        input: {
          '&::placeholder': {
            color: 'red',
          },
        },
      },
    },
  },
})

const resolver = theme => ({})

const MantineWrapper = ({ children }) => {
  React.useEffect(() => {
    const link = document.createElement('link')
    link.rel = 'stylesheet'
    link.href = '/mantine-styles.css'
    document.head.appendChild(link)
    return () => {
      document.head.removeChild(link)
    }
  }, [])
  return (
    <MantineProvider theme={mantineTheme} cssVariablesResolver={resolver}>
      {children}
    </MantineProvider>
  )
}

export default MantineWrapper
